import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AdvisoryBoardOffersState } from './advisory-board-offers.reducer';

export const selectAdvisoryBoardOffersState =
  createFeatureSelector<AdvisoryBoardOffersState>('advisoryBoardOffers');

export const selectAdvisoryBoardOffers = createSelector(
  selectAdvisoryBoardOffersState,
  (state: AdvisoryBoardOffersState) => state.offers,
);

export const selectAdvisoryBoardOffersLoading = createSelector(
  selectAdvisoryBoardOffersState,
  (state: AdvisoryBoardOffersState) => state.loading,
);

export const selectAdvisoryBoardOffersError = createSelector(
  selectAdvisoryBoardOffersState,
  (state: AdvisoryBoardOffersState) => state.error,
);

export const selectAdvisoryBoardOffersCategoryIds = createSelector(
  selectAdvisoryBoardOffersState,
  (state: AdvisoryBoardOffersState) => state.categoryIds,
);

export const selectAdvisoryBoardOffersCount = createSelector(
  selectAdvisoryBoardOffersState,
  (state: AdvisoryBoardOffersState) => state.offers.length,
);
